var map = {
	"./apple.svg": 16006,
	"./discord.svg": 85410,
	"./donatello.svg": 66836,
	"./donatepay.svg": 56438,
	"./donationalerts.svg": 27655,
	"./linux.svg": 40207,
	"./streamelements.svg": 54479,
	"./streamlabs.svg": 49505,
	"./telegram.svg": 58054,
	"./trovo.svg": 7002,
	"./twitch.svg": 25227,
	"./windows.svg": 417
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8002;